import type { ReactNode } from "react";
import { MetricValue } from "./MetricValue";

/** Body-level context; keep header actions available for actual commands. */
export function WidgetSummary({
  value,
  label,
  description,
  exactValue,
}: {
  value: ReactNode;
  label: string;
  description?: ReactNode;
  exactValue?: string;
}) {
  return (
    <div className="density-widget-body shrink-0 border-b border-border">
      <div className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-1">
        <MetricValue title={exactValue}>{value}</MetricValue>
        <span className="text-metric-caption font-medium text-secondary">{label}</span>
      </div>
      {description ? <p className="mt-1 text-metric-detail text-muted">{description}</p> : null}
    </div>
  );
}

/** Stable bottom region for result counts, scope notes and pagination actions. */
export function WidgetFooter({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return (
    <div className="flex min-h-10 shrink-0 flex-wrap items-center justify-between gap-x-3 gap-y-2 border-t border-border px-3 py-2 text-xs tabular-nums text-muted">
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">{children}</div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}
